import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { deepCopy } from '../../../../common/services/common.service';
import PageLoader from '../../../../components/PageLoader';
import { HelpTopicComponent } from '../components/help-topics/components/help-topic.component';


let currentChange: any = {}
const HelpTopicContainer= ({ onSubmit,cardDetailInfo }: any) => {  
  const [isLoading, setIsLoading] = useState<boolean>(true)
const [
  selectedHelpTopic,
    setSelectedHelpTopic
  ] = useState<any>([])
  const [
    blogPostImageIndex,
    setBlogPostImageIndex
  ] = useState<any>([])

  const [
    mediaFiles,
    setMediaFiles
  ] = useState<any>([])
  const handleFormItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(mediaFiles);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMediaFiles(items);
  }

const handleFormHelpTopicItemChange: any = ({ value, field, idx }: any) => {
  const items = deepCopy(selectedHelpTopic);// deep copy of grn items
  let item = items[idx];// deep copy of item to be edited
  item = { ...item, [field]: value }// updated the particular item
  items[idx] = item;
  currentChange = { value, field, idx }
  setSelectedHelpTopic(items);
}


  useEffect(
    () => {
      if (cardDetailInfo) {
        const localSelectedHelpTopic= addNewRow({ selectedHelpTopicArg: cardDetailInfo });
        setSelectedHelpTopic(localSelectedHelpTopic)
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: cardDetailInfo?.HelpTopicDocumentURLs });
        setMediaFiles(localSelectedMedia)
        setIsLoading(false)
    }else {
      const localSelectedHelpTopic = addNewRow({ selectedHelpTopicArg: selectedHelpTopic });
      setSelectedHelpTopic(localSelectedHelpTopic)
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
        setMediaFiles(localSelectedMedia)
        setIsLoading(false)
      }
    },
    []
  )
  const addNewRow = ({ selectedHelpTopicArg }: any) => {
    const localSelectedHelpTopic = Array.isArray(selectedHelpTopicArg)
        ? deepCopy(selectedHelpTopicArg)
        : Object.values(deepCopy(selectedHelpTopicArg));
    const newsSelectedMedia = {
       Id: 0,
       "Title": '',
       "Body": '',
       "ParentId": 0,
      HelpTopicDocumentURLs: [
        {
          Id: 0,
          HelpTopicId: 0,
          FileTypeId: 0,
          HelpTopicFileURL: 'String'
        }
      ]
    
    };

    if (
      localSelectedHelpTopic.length === 0 ||
      localSelectedHelpTopic[localSelectedHelpTopic.length - 1]?.Title !== ''
    ) {
      localSelectedHelpTopic.push(newsSelectedMedia);
    }

    return localSelectedHelpTopic;
};
  const setCombinationHelpTopicInfo = async () => {
    let localSelectedHelpTopic = deepCopy(selectedHelpTopic)
    localSelectedHelpTopic.splice(
      currentChange.idx,
      1,
      { ...localSelectedHelpTopic[currentChange.idx] }
    );
    localSelectedHelpTopic = addNewRow({ selectedHelpTopicArg: localSelectedHelpTopic });
    currentChange.field = 'TitleDONE'
    setSelectedHelpTopic(localSelectedHelpTopic)
  }

  useEffect(
    () => {
      if (currentChange.field === 'Title') {
        setCombinationHelpTopicInfo()
      }
    },
    [selectedHelpTopic]
  )

  const getIsImageRecordDeletable = (idx: any) => {
    if (mediaFiles.length - 1 === idx) {
      return false
    }
    return true
  }
const handleFormSubmit  = async (event: any) => {
  selectedHelpTopic.splice(
    selectedHelpTopic.length - 1,
    1
  );
   onSubmit(selectedHelpTopic)

  }
const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
    const localSelectedmedia = deepCopy(selectedMediaFilesArg)
    const newsSelectedMedia = {
        Id: 0,
        HelpTopicId: 0,
        FileTypeId: 0,
        HelpTopicFileURL: ''
    }
    if (localSelectedmedia.length === 0 ||
      localSelectedmedia[localSelectedmedia?.length - 1]?.FileTypeId !== 0
    ) {
      localSelectedmedia?.push(newsSelectedMedia)
    }
  
    return localSelectedmedia
  }
  const setCombinationInfo = async () => {
    let localSelectedMedia = deepCopy(mediaFiles)
    localSelectedMedia.splice(
      currentChange.idx,
      1,
      { ...localSelectedMedia[currentChange.idx] }
    );
    localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
    currentChange.field = 'FileTypeIdDONE'
    setMediaFiles(localSelectedMedia)
  }

  useEffect(
    () => {
      if (currentChange.field === 'FileTypeId') {
        setCombinationInfo()
      }
    },
    [mediaFiles]
  )
  
    return (
    <>
    {isLoading ? <PageLoader /> : 
          <HelpTopicComponent
          handleFormHelpTopicItemChange={handleFormHelpTopicItemChange}
          handleFormSubmit={handleFormSubmit}
          selectedHelpTopics={selectedHelpTopic}
          mediaFiles={mediaFiles}
          handleFormItemChange={handleFormItemChange}
          getIsImageRecordDeletable={getIsImageRecordDeletable}
          />
        }
    
          </>
    )
    
    }
   
    export default HelpTopicContainer;
